export default __webpack_public_path__ + "static/media/wap_platform_introduction_pic5.44b49081.png";